import React from "react";
import PropTypes from "prop-types";

function AreaDirectorErPlusJobsIndex(props) {
  const rows = props.data.map(job => (
    <a key={job.index} className="list-group-item u-hover--raised" href={job.href}>
      <div className="d-flex w-100 align-items-center cursor-pointer row">
        <div className={`list-status-side-bar ${job.color_class}`} title={job.color_status_in_words} />
        <div className="d-flex flex-column offset-1 col-5 col-sm-3 grey-text text-darken-3">
          {job.client_name}
          <small className="grey-text text-darken-2">{job.color_status_in_words}</small>
        </div>

        <small className="d-none d-sm-flex flex-column grey-text text-darken-2 col u-wrap">
          ER+
        </small>

        <small className="d-none d-sm-flex flex-column grey-text text-darken-2 col u-wrap">
          {job.publications}
        </small>

        <small className="d-none d-lg-flex flex-column grey-text text-darken-2 col u-wrap" title={job.modified_at}>
          {job.formatted_modified_at}
        </small>

        <div className="d-flex grey-text text-darken-2 flex-column col-1 align-items-center ml-auto">
          <i className="material-icons">keyboard_arrow_right</i>
        </div>
      </div>
    </a>
  ));

  return (
    <ul className="list-group list-group-flush mb-6">
      {rows}
    </ul>
  );
}

AreaDirectorErPlusJobsIndex.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    client_name: PropTypes.string.isRequired,
    color_class: PropTypes.string.isRequired,
    color_status_in_words: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    formatted_modified_at: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    publications: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    modified_at: PropTypes.string.isRequired,
  })).isRequired,
};

export default AreaDirectorErPlusJobsIndex
